import React, { createContext, useContext, useEffect, useState } from "react";

const BrandCtx = createContext({ brand: "amen", setBrand: () => {} });

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(() => localStorage.getItem("brand") || "amen");
  useEffect(() => {
    localStorage.setItem("brand", brand);
    // Thème global : pilote les variables CSS --brand* (rouge Amen / bleu MG)
    try { document.documentElement.dataset.brand = brand; } catch {}
  }, [brand]);

  return (
    <BrandCtx.Provider value={{ brand, setBrand }}>
      {children}
    </BrandCtx.Provider>
  );
}

export function useBrand() {
  return useContext(BrandCtx);
}
